<template>
  <v-dialog
    v-model="isShowPopup"
    width="500"
    max-width="90%"
    persistent
  >
    <v-card>
      <v-card-title
        class="headline grey lighten-2 pr-10"
        primary-title
      >
        {{title}}
        <v-spacer></v-spacer>
        <v-btn text icon color="black"
               @click="$emit('on-close')"
               absolute
               top
               right
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <slot/>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'PreviewPopup',
  props: {
    isShowPopup: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped>

</style>
